import {
  FC,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Loading } from 'react-admin';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { OpenAPI, UserService } from '../../shared/api';

export const AuthProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const isLoginPage = useMemo(
    () => location.pathname === '/login',
    [location.pathname]
  );

  const checkAuth = useCallback(async () => {
    try {
      if (!isAuthenticated && !isLoginPage) {
        const token = localStorage.getItem('token') ?? '';
        OpenAPI.TOKEN = token;
        await UserService.checkUserToken();
        setIsAuthenticated(true);
      }
    } catch (e) {
      setIsAuthenticated(false);
      navigate('/login');
    }
  }, [isAuthenticated, isLoginPage, navigate]);

  useEffect(() => {
    checkAuth();
  }, [location, checkAuth]);

  if (isAuthenticated || isLoginPage) {
    return <>{children}</>;
  }

  return (
    <div className={styles.Loading}>
      <Loading
        loadingPrimary="Проверка"
        loadingSecondary="Проверяем, уровень Вашего доступа"
      />
    </div>
  );
};
